export const MENU_COLLAPSED = 'MENU_COLLAPSED'
export const CHANGE_LOGIN_STATUS = 'CHANGE_LOGIN_STATUS'
export const SET_ALL_ENUM = 'SET_ALL_ENUM'
export const SET_LOGIN_USER = 'SET_LOGIN_USER'
export const SET_PERSONALIZE = 'SET_PERSONALIZE'
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_BALANCE = 'SET_BALANCE'
